// extracted by mini-css-extract-plugin
export default {"expandButton":"OJQ_3L"};